// extracted by mini-css-extract-plugin
export default {"storeInfo":"StoreCard_storeInfo__qBhWJ","imgContainer":"StoreCard_imgContainer__z04mo","storeName":"StoreCard_storeName__eJLlH","commission":"StoreCard_commission__HGGeb"};